import type { FC } from 'react';

import { components } from 'react-select';

import type { PlaceholderProps } from 'react-select';
import type { OptionType } from 'shared/ui-kit';

interface CustomPlaceholderProps extends PlaceholderProps<OptionType> {}

const Placeholder: FC<CustomPlaceholderProps> = ({ children, ...props }) => {
  return <components.Placeholder {...props}>{children}</components.Placeholder>;
};

export default Placeholder;
